export const fetchSession = async ({ BeURL, id }) => {
    try {

        const res = await fetch(
            `${BeURL}/fetch-session?id=${id}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        const data = await res.json();

        return data;

    } catch (err) {

        console.log("Fetch Session error", err);

        return {
            success: false,
            message: err.message
        };
    }
};
